"use client";

import { MATCH_STATUS as STATUS } from "contants";
import { formatDateTime } from "@/utils/format";

export default function HBetKbvMatchMinute({
  liveScore,
  status,
  matchTime,
  halfStartTime,
  className = "",
  showDate = false,
  stacked = false,
}) {
  const isCheckingVar = !!liveScore?.var;
  let matchStatus = "--";
  let currentMinute = null;
  let showMatchTime = false;

  // check var
  if (isCheckingVar) {
    return <span className={className}>VAR</span>;
  }

  // prioritize live data
  const currentStatus = liveScore?.status !== undefined
    ? Number(liveScore.status)
    : status;

  if (
    liveScore?.minute !== undefined ||
    liveScore?.currentMinute !== undefined
  ) {
    currentMinute = liveScore?.minute ?? liveScore?.currentMinute;
    showMatchTime = true;
  } else {
    const timeStart = liveScore?.halfStartTime || (currentStatus === STATUS.FIRST_HALF ? matchTime : halfStartTime);
    const currentTime = Math.floor(Date.now() / 1000);

    if (timeStart != null && timeStart !== "") {
      const startTimeUnix =
        !isNaN(Number(timeStart))
          ? Number(timeStart)
          : Math.floor(new Date(timeStart).getTime() / 1000);

      switch (currentStatus) {
        case STATUS.FIRST_HALF:
          showMatchTime = true;
          currentMinute = Math.floor((currentTime - startTimeUnix) / 60);
          if (currentMinute >= 45) {
            currentMinute = `45+${currentMinute - 45}`;
          }
          break;

        case STATUS.SECOND_HALF:
          showMatchTime = true;
          if (!Number.isFinite(Number(timeStart)) || Number(timeStart) <= 0) {
            currentMinute = 45;
            break;
          }
          const secondHalfMinute = 45 + Math.floor((currentTime - Number(timeStart)) / 60);
          if (!Number.isFinite(secondHalfMinute) || secondHalfMinute < 45) {
            currentMinute = 45;
            break;
          }
          currentMinute = secondHalfMinute;
          if (currentMinute >= 90) {
            currentMinute = `90+${currentMinute - 90}`;
          }
          break;

        case STATUS.EXTRA_TIME:
          showMatchTime = true;
          currentMinute = `ET+${Math.floor((currentTime - startTimeUnix) / 60)}`;
          break;

        case STATUS.HALF_TIME_BREAK:
          matchStatus = "HẾT H1";
          break;

        case STATUS.NOT_STARTED:
          showMatchTime = false;
          const { time  } = formatDateTime(matchTime);
          matchStatus = time;
          break;

        case STATUS.FINISHED:
          matchStatus = "Kết Thúc";
          showMatchTime = false;
          break;

        case STATUS.TERMINATED:
          matchStatus = "Huỷ";
          break;

        case STATUS.POSTPONED:
          matchStatus = "Hoãn";
          break;

        case STATUS.INTERRUPTED:
          matchStatus = "Gián Đoạn";
          break;

        default:
          showMatchTime = false;
          break;
      }
    }
  }

  const getPhaseLabel = (currentStatus) => {
    switch (currentStatus) {
      case STATUS.FIRST_HALF:
        return "Hiệp 1";
      case STATUS.SECOND_HALF:
        return "Hiệp 2";
      case STATUS.EXTRA_TIME:
        return "Hiệp phụ";
      default:
        return matchStatus; // fallback to status text for non-live statuses
    }
  };

  if (showMatchTime && currentMinute !== null) {
    const phaseLabel = getPhaseLabel(currentStatus);

    return (
      <span className={`whitespace-nowrap font-normal ${className}`}>
        {phaseLabel && <span className="mr-[4px]">{phaseLabel}</span>}
        {currentMinute}
        <span className="animate-blink">&apos;</span>
      </span>
    );
  }

  if (showDate && matchTime && !showMatchTime) {
    const { date: mDate, time: mTime } = formatDateTime(matchTime);
    const finalDisplayTime = (matchStatus && matchStatus !== "--" && isNaN(Number(matchStatus[0]))) ? matchStatus : mTime;

    if (stacked) {
      return (
        <div className={`flex flex-col leading-tight ${className}`}>
          <span>{finalDisplayTime}</span>
          <span>{mDate}</span>
        </div>
      );
    }
    return (
      <span className={`whitespace-nowrap font-normal ${className}`}>
        {finalDisplayTime} - {mDate}
      </span>
    );
  }

  return (
    <span className={`whitespace-nowrap font-normal ${className}`}>
      {matchStatus}
    </span>
  );
}